import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';

import { getCountry } from '../../common/utils';
import { DASH_GLOBE, VERSION_TICK } from '../../config/media';

const getVersionDetails = (version, isUpgrade) => {
    if (version) {
        return (
            <Fragment>
                {`HollaEx Kit v${version}`}{' '}
                {isUpgrade
                    ? <Icon type="exclamation-circle" style={{ fontSize: '16px', color: '#0000FF' }} />
                    : <img src={VERSION_TICK} alt="tick" className="details-icon" />
                }{' '}
                <Link to="/hosting?tab=2">(View)</Link>
            </Fragment>
        )
    }
    return ('N/A');
};

const ExchangeDetails = ({ exchange = {}, constant = {}, handleUpgrade = () => { } }) => {
    // const imgIndex = ((exchange.id || 0) % 6) + 1;
    const isUpgrade = !!(exchange.version
        && constant.kitVersion !== exchange.version)
    const info = exchange.info && exchange.info.public && exchange.info.public.country ? exchange.info : {
        ...exchange.info, public: { ...exchange.info.public, country: exchange.info.biz.DEFAULT_COUNTRY }
    }
    return (
        <div className="flex-content">
            <div className='img-container'>
                <img
                    src={DASH_GLOBE}
                    alt="Exchange logo"
                    className="exchange-logo"
                />
            </div>
            <div>
                <div><span className="details-menu">Name:</span>{exchange.display_name}{' '}<Link to="/general">(View)</Link></div>
                <div>
                    <span className="details-menu">Country:</span>
                    {getCountry(info, true)}{' '}
                    <Link to="/general">(View)</Link>
                </div>
                <div><span className="details-menu">Hosting type:</span>{exchange.type}{' '}<Link to="/hosting">(View)</Link></div>
                <div>
                    <span className="details-menu">Domain:</span>
                    {exchange.domain ? exchange.domain : '(not set)'}{' '}
                    {exchange.type === 'Cloud'
                        ? <Link to="/hosting?tab=1">(View)</Link>
                        : <Link onClick={handleUpgrade}>(View)</Link>
                    }
                </div>
                <div>
                    <span className="details-menu">Version: </span>
                    {getVersionDetails(exchange.version, isUpgrade)}
                </div>
            </div>
        </div>
    )
}

export default ExchangeDetails;
